"use strict";

exports.__esModule = true;
exports.loadable = loadable;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createLoadedComponentsCache() {
  var loadedComponent = [];
  return {
    get: function get(loadComponent) {
      var hit = loadedComponent.find(function (_ref) {
        var f = _ref[0];
        return f === loadComponent;
      });

      if (hit) {
        return hit[1];
      } else {
        return null;
      }
    },
    set: function set(loadComponent, comp) {
      return loadedComponent.push([loadComponent, comp]);
    }
  };
}

function loadWithRetry(loadComponent, retries) {
  if (retries === void 0) {
    retries = 3;
  }

  return loadComponent()["catch"](function (e) {
    if (retries > 0) {
      console.warn('loadComponent failed; reties left', retries);
      return loadWithRetry(loadComponent, retries - 1);
    } else {
      return Promise.reject(e);
    }
  });
}

var loadedComponents = createLoadedComponentsCache();

function loadable(loadComponent, _temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      _ref2$loading = _ref2.loading,
      loading = _ref2$loading === void 0 ? function () {
    return null;
  } : _ref2$loading,
      _ref2$resolveComponen = _ref2.resolveComponent,
      resolveComponent = _ref2$resolveComponen === void 0 ? function (module) {
    return module["default"];
  } : _ref2$resolveComponen;

  var loadComponentPromise;

  var Loadable = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(Loadable, _React$Component);

    function Loadable() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

      _defineProperty(_assertThisInitialized(_this), "state", {
        Component: null
      });

      return _this;
    }

    Loadable.load = function load() {
      if (!loadComponentPromise) {
        loadComponentPromise = loadWithRetry(loadComponent);
      }

      return loadComponentPromise;
    };

    Loadable.getDerivedStateFromProps = function getDerivedStateFromProps() {
      var comp = loadedComponents.get(loadComponent);

      if (comp) {
        return {
          Component: comp
        };
      } else {
        return null;
      }
    };

    var _proto = Loadable.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;

      if (!this.state.Component) {
        Loadable.load().then(function (module) {
          var comp = resolveComponent(module);
          loadedComponents.set(loadComponent, comp);

          _this2.setState({
            Component: comp
          });
        })["catch"](function (err) {
          return console.error('Failed to load async component', err);
        });
      }
    };

    _proto.render = function render() {
      var Component = this.state.Component;
      var loadableLoading = this.props.loadableLoading;
      var showLoader = loadableLoading || loading;
      return Component ? /*#__PURE__*/_react["default"].createElement(Component, this.props) : showLoader(this.props);
    };

    return Loadable;
  }(_react["default"].Component);

  return Loadable;
}